<template>
  <div>
    <div class="d-flex flex-wrap justify-space-between mb-4">
      <h2 class="mb-4">Interests</h2>
    </div>
    <div>
      <v-card style="padding: 20px">
        <v-form ref="form">
          <div :key="index" v-for="(item, index) in entity" class="d-flex flex-column">
            <div class="d-inline-flex">
              <v-btn v-if="item.id" fab x-small depressed disabled>
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
              <v-text-field v-model="item.name" :label="item.oldName ? item.oldName : 'Group Name'" :rules="[(v) => !!v || 'This field is required']" outlined dense></v-text-field>
              <v-btn @click="removeGroup(index, item.id)" color="red" icon dark>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>

            <div :key="indexChild" v-for="(itemChild, indexChild) in item.child" class="d-inline-flex flex-row-reverse ma-0 pa-0">
              <v-col class="d-inline-flex" cols="8">
                <v-btn v-if="itemChild.id" fab x-small depressed disabled>
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-text-field v-model="itemChild.name" :label="itemChild.oldName ? itemChild.oldName : 'Interest'" :rules="[(v) => !!v || 'This field is required']" outlined dense></v-text-field>
                <v-btn @click="removeChild(index, indexChild, itemChild.id)" color="red" icon dark>
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-col>
            </div>
            <div class="d-inline-flex flex-row-reverse">
              <v-col cols="8" style="padding-top:0; margin-top:-28px; margin-bottom:10px">
                <v-btn @click="addInterest(index)" color="primary darken-1" small :disabled="!item.name">Add Interest</v-btn>
              </v-col>
            </div>
            <v-divider></v-divider>
          </div>
          <div>
            <v-btn @click="addGroup()" color="primary darken-1" small :disabled="!entity[entity.length - 1].name">Add Group</v-btn>
          </div>
          <v-divider></v-divider>
          <div class="text-right">
            <v-btn @click="bulkUpdate()" color="primary darken-1">Save</v-btn>
          </div>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  props: ["experienceId"],
  data() {
    return {
      entity: [
        {
          child: []
        }
      ]
    };
  },
  mounted() {
    this.list();
  },
  methods: {
    list() {
      axios
        .get("/system/interest/tree?experienceId=" + this.experienceId)
        .then((response) => {
          if (response.data.length > 0) {
            this.entity = response.data;
          }
        })
        .catch(() => {});
    },
    addGroup() {
      this.entity.push({
        child: []
      });
    },
    addInterest(index) {
      this.entity[index].child.push({});
    },
    bulkUpdate() {
      if (this.$refs.form.validate()) {
        axios
          .post("/system/common/interest/bulk/update", {
            experienceId: this.experienceId,
            interestList: this.entity
          })
          .then(() => {
            this.list();
          })
          .catch(() => {});
      }
    },
    removeGroup(index, id) {
      if (id && confirm("All interest within selected group will also be deleted, Are you sure you want to delete ?")) {
        axios
          .post("/system/interest/delete", {
            id: id
          })
          .then(() => {
            this.entity.splice(index, 1);
          })
          .catch(() => {});
      } else if (!id) {
        this.entity.splice(index, 1);
      }
    },
    removeChild(index, indexChild, id) {
      if (id && confirm("Selected interest will also be removed from users, Are you sure you want to delete ?")) {
        axios
          .post("/system/interest/delete", {
            id: id
          })
          .then(() => {
            this.entity[index].child.splice(indexChild, 1);
          })
          .catch(() => {});
      } else if (!id) {
        this.entity[index].child.splice(indexChild, 1);
      }
    }
  }
};
</script>